import styled from "styled-components";
import BasicTitle from "./title";
import Button from "@mui/material/Button";

const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    animation: fadeIn 0.2s ease-in-out;

    @keyframes fadeIn {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }
`;

const UpgradeModalContainer = styled.div`
    position: relative;
    display: flex;
    width: 600px;
    padding: 40px;
    flex-direction: column;
    align-items: flex-start;
    gap: 24px;
    border-radius: 8px;
    background: var(--Light-Pure, #fff);
    animation: slideUp 0.3s ease-in-out;

    @keyframes slideUp {
        from {
            transform: translateY(20px);
            opacity: 0;
        }
        to {
            transform: translateY(0);
            opacity: 1;
        }
    }
`;

const TextUsersActive = styled.p`
    color: #181122;
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 133%;
    letter-spacing: -0.14px;
`;

const ModalSpecialText = styled.p`
    color: #181122;
    font-family: Montserrat;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 133%;
    letter-spacing: -0.12px;
`;

const UpgradePlanBox = styled.div`
    display: flex;
    padding: 16px;
    flex-direction: column;
    align-items: flex-start;
    gap: 0;
    align-self: stretch;
    border-radius: 8px;
    border: 2px solid #463694;
    background: #f4f2fb;
`;

const UpgradePlanTitle = styled.div`
    color: #473694;
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
`;

const UpgradePlanPrice = styled.div`
    color: var(--Secundary-Pure, #181122);
    font-family: Montserrat;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
`;

const ModalButtonsRow = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
    gap: 16px;
`;

const PrimaryButton = styled(Button)`
    && {
        background: #57c4c2;
        color: #000;
        font-family: Montserrat;
        font-size: 14px;
        font-weight: 600;
        text-transform: none;
        padding: 12px 24px;
        border-radius: 8px;
        text-transform: uppercase;

        &:hover {
            background: #4ba09b;
        }

        &:disabled {
            background: #e4e4e4;
            color: #999;
        }
    }
`;

const ModalClose = styled.img`
    position: absolute;
    right: 20px;
    top: 20px;
    cursor: pointer;
`;

export default function ModalSpecialPlanOffer({
    open,
    onClose,
    activeUsersCount,
    zIndex,
}) {
    const handleContactClick = async () => {
        const contactFormUrl = process.env.REACT_APP_CONTACT_FORM_URL;
        if (contactFormUrl) {
            window.open(contactFormUrl, '_blank');
        }
        onClose();
    };

    const handleClose = () => {
        onClose();
    };

    if (!open) return null;

    return (
        <ModalOverlay onClick={handleClose} style={{ zIndex: zIndex || 8000 }}>
            <UpgradeModalContainer onClick={(e) => e.stopPropagation()}>
                <ModalClose
                    src="/img/modal_close.svg"
                    onClick={handleClose}
                />
                <BasicTitle title="Fazer Upgrade" margin={0} />

                <div>
                    <TextUsersActive>Total de usuários: {activeUsersCount}</TextUsersActive>
                    <ModalSpecialText>
                        Você já atingiu o limite de usuários para o seu plano.
                    </ModalSpecialText>
                </div>

                <UpgradePlanBox>
                    <UpgradePlanPrice>
                        Sob consulta
                    </UpgradePlanPrice>
                    <UpgradePlanTitle>
                        + de 99 usuários
                    </UpgradePlanTitle>
                </UpgradePlanBox>

                <ModalButtonsRow>
                    <PrimaryButton
                        onClick={handleContactClick}
                    >
                        Fale com o nosso time
                    </PrimaryButton>
                </ModalButtonsRow>
            </UpgradeModalContainer>
        </ModalOverlay>
    );
}
